import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SidebarStateService {
  private _collapsed = new BehaviorSubject<boolean>(
    localStorage.getItem('sidebarCollapsed') === 'true'
  );
  collapsed$ = this._collapsed.asObservable();

  get collapsed(): boolean {
    return this._collapsed.value;
  }

  setCollapsed(value: boolean) {
    this._collapsed.next(value);
    localStorage.setItem('sidebarCollapsed', String(value));
  }

  toggle() {
    this.setCollapsed(!this._collapsed.value);
  }
}
